import { List } from "immutable";
import React from "react";
// import * as BS from "react-bootstrap";
import { TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as redux from "redux";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import { Statuses } from "../../../domain";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { Utility } from "../../../utils";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    api: new Api(state),
    dataLoading: state.adminPageListState.loading,
    pages: state.adminPageListState.pages,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    loadData: () => dispatch(Actions.AdminPageList.loadData()),
    notifyError: (message: string, icon?: string) => dispatch(Actions.Noti.notifyError(message, icon)),
    notifySuccess: (message: string, icon?: string) => dispatch(Actions.Noti.notifySuccess(message, icon)),
    updateNavItem: (pages: List<M.AdminPage.ListItem>) => dispatch(Actions.AdminPageList.updatePages(pages)),
});

interface OwnProps {
}

interface ConnectedState {
    api: Api;
    dataLoading: boolean;
    pages: List<M.AdminPage.ListItem>;
}

interface ConnectedDispatch {
    loadData: () => void;
    notifyError: (message: string, icon?: string) => void;
    notifySuccess: (message: string, icon?: string) => void;
    updateNavItem: (pages: List<M.AdminPage.ListItem>) => void;
}

interface OwnState {
    dataFiltered: M.AdminPage.ListItem[];
    doFilter: boolean;
    statuses: { [index: number]: M.Generic.TypeDefinition; };
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class ListViewComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    private _confirmDelete: Comp.Modal.ConfirmModal | null = null;

    public constructor(props: any) {
        super(props);
        this.state = {
            dataFiltered: [],
            doFilter: false,
            loading: false,
            statuses: Utility.createNumberIndexMap(Statuses.Values, (s) => s.id),
        };
    }

    public componentWillMount() {
        this.props.loadData();
    }

    public componentDidMount() {
        this._isMounted = true;
        this.triggerDataFilter();
    }

    public componentDidUpdate() {
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public componentWillReceiveProps(nextProps: Readonly<CombinedProps>, nextContext: any) {
        this.triggerDataFilter();
    }

    public shouldComponentUpdate?(nextProps: Readonly<CombinedProps>, nextState: Readonly<OwnState>, nextContext: any): boolean {
        if (nextState.doFilter) {
            this.filterData(nextProps.pages);
            return false;
        }

        return true;
    }

    public render() {
        const data = this.props.pages.toArray();
        const actionsPrimary = undefined;
        // const actionsPrimary = <BS.ButtonToolbar>
        //         <BS.ButtonGroup>
        //             <BS.Button bsStyle="default" id="" onClick={() => {}}>
        //                 <i className="fa fa-plus"></i> Add new page
        //             </BS.Button>
        //         </BS.ButtonGroup>
        //     </BS.ButtonToolbar>;

        return <Comp.Page.AdminPage breadcrumb={[ <Link to={Paths.Admin.Landing}>Admin</Link> ]} title="Pages">
            <Comp.Modal.ConfirmModal
                headerClassName="warning"
                onProceed={() => this.deletePage()}
                title="Confirm delete"
                ref={(ref) => this._confirmDelete = ref}
            >
                <p>Are you sure you want to delete this page?</p>
            </Comp.Modal.ConfirmModal>

            <div className="results" style={{ position: "relative" }}>
                <Comp.Generic.LoadingSpinner show={this.state.loading || this.props.dataLoading} />

                <div className="results-list">
                    <Comp.Table.BootstrapTableEnhanced
                        actionsPrimary={actionsPrimary}
                        bsTable={{
                            data: this.state.dataFiltered,
                            options: {
                                // onSortChange: (name: any, order: any) => { console.log("sort", name, order); },
                            },
                        }}
                        totalDataRows={data.length}
                    >
                        <TableHeaderColumn
                            dataField="id"
                            dataFormat={(cell, row: M.AdminPage.ListItem) => <Link to={Paths.AdminPage.Edit + "/" + row.id}>Edit</Link>}
                            isKey
                            searchable={false}
                            width="50px"
                        ></TableHeaderColumn>

                        <TableHeaderColumn
                            dataField="title"
                            dataFormat={(cell, row: M.AdminPage.ListItem) => this.formatColTitle(row)}
                            dataSort
                        >Title</TableHeaderColumn>

                        <TableHeaderColumn
                            dataField="updatedBy"
                            dataFormat={(cell, row: M.AdminPage.ListItem) => Comp.Table.BootstrapTableHelpers.formatUserFullName(row.updatedBy)}
                            dataSort
                            searchable={false}
                            width="250px"
                        >Updated by</TableHeaderColumn>

                        <TableHeaderColumn
                            dataField="updatedOn"
                            dataFormat={(cell, row: M.AdminPage.ListItem) => ""}
                            dataSort
                            defaultASC={false}
                            searchable={false}
                            width="210px"
                        >Updated on</TableHeaderColumn>

                        <TableHeaderColumn
                            dataField="statusId"
                            dataFormat={(cell, row: M.AdminPage.ListItem) => Comp.Table.BootstrapTableHelpers.formatByIndexMap(row, (n) => n.statusId, this.state.statuses, (s) => s.name)}
                            dataSort
                            searchable={false}
                            width="100px"
                        >Status</TableHeaderColumn>

                        <TableHeaderColumn
                            dataField="id"
                            dataFormat={(cell, row: M.AdminPage.ListItem) =>
                                row.url === "/"
                                    ? "" // don't allow deleting of home page
                                    : <Comp.Generic.IconLink className="req" icon="times" onClick={() => this.toggleDeleteConfirmation(row)} to="#" />}
                            searchable={false}
                            width="40px"
                        ></TableHeaderColumn>

                    </Comp.Table.BootstrapTableEnhanced>
                </div>
            </div>
        </Comp.Page.AdminPage>;
    }

    private async deletePage() {
        if (this._confirmDelete === null)
            return;

        const page = this._confirmDelete.getRef() as M.AdminNav.NavListItem;
        if (page === undefined) {
            this.props.notifyError("Page is undefined in the confirmation modal.");
            return;
        }

        const queryParams = { id: page.id };
        this.props.api.delete<boolean>(Api.endpoints.admin.page.page, { queryParams })
            .then((result) => {
                if (result.isSuccess) {
                    this.onPageDeleted(page);
                    this.props.notifySuccess(`Page <strong>${page.title}</strong> has been successfully deleted.`);
                }
                else {
                    let error = result.errors.join("<br />");
                    if (result.errorCode === 402) // when page's nav item has children
                        error = `Page's navigation record has child navigation items.<br />Delete children first before deleting this page.`;
                    else if (result.errorCode === 403) // when pages' nav item is locked
                        error = `Page's navigation record is locked and cannot deleted.`;
                    throw new Error (error);
                }
            }, (err) => {

            })
            .catch((err) => {
                this.props.notifyError(err);
            })
            .then(() => {
                if (this._confirmDelete !== null)
                    this._confirmDelete.close();
            });
    }

    private filterData(navItems: List<M.AdminPage.ListItem>) {
        const dataFiltered: M.AdminPage.ListItem[] = [];

        navItems.forEach((n, i) => {
            if (n) {
                const isFiltered = true;

                if (isFiltered) {
                    dataFiltered.push(n);
                }
            }
        });

        this.setState({
            ...this.state,
            doFilter: false,
            dataFiltered,
        });
    }

    private formatColTitle(page: M.AdminPage.ListItem) {
        let link = null;

        if (page.statusId === 1 && page.url)
            link = <Link to={(page.url || "")} target="_blank"><i className="fa fa-external-link"></i></Link>;

        return <span>{page.title} {link}</span>;
    }

    /**
     * Callback after navigation item is deleted
     * @param page The deleted page
     */
    private onPageDeleted(page: M.AdminNav.NavListItem) {
        const idx = this.props.pages.findIndex((p) => p !== undefined && p.id === page.id);

        if (idx > -1) {
            const pages = this.props.pages.delete(idx);

            // trigger a refetch of navigation items for the app
            // this.props.expectNavigationToReload();
            this.props.updateNavItem(pages);
        }
    }

    private toggleDeleteConfirmation(page: M.AdminPage.ListItem) {
        if (this._confirmDelete !== null) {
            this._confirmDelete.show(page);
        }
    }

    private triggerDataFilter() {
        this.setState({ ...this.state, doFilter: true });
    }
}

export const ListView: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(ListViewComponent);



// WEBPACK FOOTER //
// ./src/containers/adminPage/list/List.tsx